let once = true;

function obCallbackActivateCounter(payload) {
  if (payload[0].isIntersecting && once) {
    $('.observe-counter').each(function () {
      $(this)
        .prop('Counter', 0)
        .animate(
          {
            Counter: Number($(this).text()),
          },
          {
            duration: 4000,
            easing: 'swing',
            step(now) {
              const txt = Math.ceil(now).toString();
              if (txt.length > 4) {
                const out = `${txt.slice(0, 2)} ${txt.slice(2)}`;
                $(this).text(out);
              } else {
                $(this).text(txt);
              }
            },
          },
        );
    });
    once = false;
  }
}

export default function observeCounter() {
  const observeSection = document.querySelector('.observe-counter-trigger');
  if (observeSection !== null) {
    const observer = new IntersectionObserver(obCallbackActivateCounter);
    observer.observe(observeSection);
  }
}

export function headerOffset() {
  changeOffset();
  window.addEventListener('resize', () => {
    changeOffset();
  });
}

function changeOffset() {
  const topOffset = document.querySelector('.header-box').offsetHeight;
  document.querySelector('body').style.paddingTop = `${topOffset}px`;
  document.querySelector('.megamenu-wrapper').style.top = `${topOffset}px`;
}
